import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { APP_LEAVING } from '../../constants/ActionTypes';

import CTModal from '../helpers/CTModal';

class ModalPropertyHelp extends Component {
    constructor(props) {
        super(props);
        this.onClose = this.onClose.bind(this);
        this.state = {};
    }

    onClose() {
        this.props.close();
    }

    render() {
        return (
            <CTModal
                open={this.props.open}
                primaryButtonTitle="Ok"
                primaryButton
                primaryButtonClick={this.onClose}
                onClose={this.onClose}
            >
                <div className="spark-message spark-message--lg spark-message--info spark-panel">
                    <div className="spark-panel__content">
                        <i className="spark-message__icon spark-icon-note spark-icon--fill" />
                        <div className="spark-message__content">
                            <h4 className="spark-message__heading">Help for Property selection</h4>
                            <p>Call HS Helpdesk</p>
                            <p>or follow these steps:</p>
                            <ul>
                                <li>Shutdown your Windows PC</li>
                                <li>Open the window (the physical one)</li>
                                <li>Throw it out</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </CTModal>
        );
    }
}

ModalPropertyHelp.defaultProps = {
    open: false
};

ModalPropertyHelp.propTypes = {
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired
};

/**
 STORE stuff. See store/AppStore.js
*/

export const SHOW_MODAL_PROPERTY_HELP = 'SHOW_MODAL_PROPERTY_HELP';
export const HIDE_MODAL_PROPERTY_HELP = 'HIDE_MODAL_PROPERTY_HELP';

const initialState = {
    isOpened: false
};

export const modalPropertyHelpReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_MODAL_PROPERTY_HELP:
            return {
                isOpened: true
            };
        case HIDE_MODAL_PROPERTY_HELP:
        case APP_LEAVING:
            return {
                isOpened: false
            };
        default:
            return state;
    }
};

export const modalPropertyHelpActions = {
    show() {
        return dispatch => {
            dispatch({ type: SHOW_MODAL_PROPERTY_HELP });
        };
    },
    hide() {
        return dispatch => {
            dispatch({ type: HIDE_MODAL_PROPERTY_HELP });
        };
    }
};

/**
 /STORE stuff. See store/AppStore.js
*/

const mapStateToProps = state => {
    return {
        open: state.app.modal.propertyHelp.isOpened
    };
};

const mapDispatchToProps = dispatch => ({
    close: () => dispatch(modalPropertyHelpActions.hide())
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalPropertyHelp);



// WEBPACK FOOTER //
// ./src/components/modals/ModalPropertyHelp.js